import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { EmailService } from '../../services/email.service';

@Component({
  selector: 'df-email-unsubscribe',
  templateUrl: './email-unsubscribe.component.html',
  styleUrls: ['./email-unsubscribe.component.scss']
})
export class EmailUnsubscribeComponent implements OnInit {
  unsubscribeForm!: FormGroup;
  showMessage = false;
  messageText = '';
  isSuccess = false;
  isSubscribed = false;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private emailService: EmailService
  ) {}

  ngOnInit(): void {
    this.unsubscribeForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]]
    });
  }

  get email() {
    return this.unsubscribeForm.get('email');
  }

  onUnsubscribe(): void {
    if (this.unsubscribeForm.valid) {
      const email = this.unsubscribeForm.value.email;

      this.emailService.unsubscribe(email).subscribe({
        next: (response) => {
          this.showMessage = true;
          this.messageText = 'You are unsubscribed!';
          this.isSuccess = true;
        },
        error: (error) => {
          this.showMessage = true;
          this.messageText = 'Email not found';
          this.isSuccess = false;
          console.error('Unsubscribe error:', error);
        }
      });
    }
  }

  onSubscribe(): void {
    if (this.unsubscribeForm.valid) {
      const email = this.unsubscribeForm.value.email;
      this.isSubscribed = true;

      this.emailService.subscribe(email).subscribe({
        next: (response) => {
          this.showMessage = true;
          this.messageText = 'You have been subscribed again!';
          this.isSuccess = true;
          this.isSubscribed = false;
        },
        error: (error) => {
          this.showMessage = true;
          this.messageText = 'Failed to subscribe. Please try again.';
          this.isSuccess = false;
          this.isSubscribed = false;
          console.error('Subscribe error:', error);
        }
      });
    }
  }

  onCancel(): void {
    // Navigate back to home page or previous page
    this.router.navigate(['/']);
  }
}
